import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      'Cybersecurity Awareness Training': 'Cybersecurity Awareness Training',
      Email: 'Email',
      Password: 'Password',
      Language: 'Language',
      Login: 'Login',
      English: 'English',
      'Chinese (Simplified)': 'Chinese (Simplified)',
      'Chinese (Traditional)': 'Chinese (Traditional)',
      'Not registered yet?': 'Not registered yet?',
      'Register now': 'Register now',
      'Register account': 'Register account',
      'Valid email address': 'Valid email address',
      'Use 8 or more characters with a mix of letters and numbers': 'Use 8 or more characters with a mix of letters and numbers',
      'Confirm password': 'Confirm password',
      'Enter password again': 'Enter password again',
      'Company name': 'Company name',
      Location: 'Location',
      Register: 'Register',
      'Already have an account?': 'Already have an account?',
      'Online Training Class': 'Online Training Class',
      Main: 'Main',
      Course: 'Course',
      Mission: 'Mission',
      User: 'User',
      Report: 'Report',
      Logout: 'Logout',
      'Copyright 2022 Hoplite Technology Limited, All Rights Reserved.': 'Copyright 2022 Hoplite Technology Limited, All Rights Reserved.',
      'Courses / Quizzes List': 'Courses / Quizzes List',
      'Add mission': 'Add mission',
      'Mission name': 'Mission name',
      'End Date': 'End Date',
      'End Time': 'End Time',
      Title: 'Title',
      Score: 'Score',
      score: 'score',
      scores: 'scores',
      Description: 'Description',
      'Max 100 words': 'Max 100 words',
      Department: 'Department',
      Save: 'Save',
      'Upload image': 'Upload image',
      Select: 'Select',
      'Video URL': 'Video URL',
      Return: 'Return',
      Confirm: 'Confirm',
      Edit: 'Edit',
      Completed: 'Completed',
      Approved: 'Approved',
      'User List': 'User List',
      Admin: 'Admin',
      Status: 'Status',
      ACTIVE: 'ACTIVE',
      INACTIVE: 'INACTIVE',
      Active: 'Active',
      Inactive: 'Inactive',
      Tel: 'Tel',
      'Job type': 'Job type',
      Role: 'Role',
      Company: 'Company',
      'Last login': 'Last login',
      'Add user': 'Add user',
      'Add new user': 'Add new user',
      'Full-Time': 'Full-Time',
      'Part-Time': 'Part-Time',
      None: 'None',
      'full-time': 'Full-Time',
      'part-time': 'Part-Time',
      none: 'None',
      'platform-admin': 'platform-admin',
      'division-admin': 'division-admin',
      trainee: 'trainee',
      'Platform-Admin': 'Platform-Admin',
      'Division-Admin': 'Division-Admin',
      Trainee: 'Trainee',
      'Platform Admin': 'Platform Admin',
      'Division Admin': 'Division Admin',
      FILTERS: 'FILTERS',
      RESET: 'RESET',
      'Courses / Quizzes Report': 'Courses / Quizzes Report',
      'Export report': 'Export report',
      'Export Report': 'Export Report',
      Quiz: 'Quiz',
      'Completed rate': 'Completed rate',
      'Average score': 'Average score',
      'Passing rate': 'Passing rate',
      'Send Reminder Email to Uncompleted Users': 'Send Reminder Email to Uncompleted Users',
      Back: 'Back',
      'Start Time': 'Start Time',
      'Completed Time': 'Completed Time',
      Reminder: 'Reminder',
      Send: 'Send',
      'Mission Report': 'Mission Report',
      'Submit rate': 'Submit rate',
      'Approval rate': 'Approval rate',
      'Approve Submission': 'Approve Submission',
      'Uploaded Time': 'Uploaded Time',
      'Approval Time': 'Approval Time',
      Approval: 'Approval',
      'Your course': 'Your course',
      'Your mission': 'Your mission',
      'Your result': 'Your result',
      Hi: 'Hi',
      'Let\'s learn something new today': 'Let\'s learn something new today',
      hr: 'hr',
      Performance: 'Performance',
      'Hour spent': 'Hour spent',
      Expired: 'Expired',
      'Mission step': 'Mission step',
      'This mission is time over. Please contact the admin re-open.': 'This mission is time over. Please contact the admin re-open.',
      Close: 'Close',
      'Please enter the valid email': 'Please enter the valid email',
      'Delete User': 'Delete User',
      delete_user: 'User: {{uid}} will be deleted.',
      Cancel: 'Cancel',
      'Reset password': 'Reset password',
      'Reset this user password': 'Reset this user password',
      'Reset password successfully': 'Reset password successfully',
      Copy: 'Copy',
      'This UID has been created in this company.': 'This UID has been created in this company.',
      Export: 'Export',
      Selected: 'Selected',
      'Select All': 'Select All',
      Approve: 'Approve',
      'Items per page': 'Items per page',
      'Online training course': 'Online training course',
      Weekly: 'Weekly',
      'Edit user': 'Edit user',
      'Edit mission': 'Edit mission',
      'Rows per page': 'Rows per page',
      'Welcome to Online Training Class': 'Welcome to Online Training Class',
    },
  },
  cn_t: {
    translation: {
      'Cybersecurity Awareness Training': '網絡安全意識培訓',
      Email: '電郵',
      Password: '密碼',
      Language: '語言',
      Login: '登入',
      'Not registered yet?': '沒有帳戶？',
      'Register now': '立即註冊',
      English: '英语',
      'Chinese (Simplified)': '簡體中文',
      'Chinese (Traditional)': '繁體中文',
      'Register account': '註冊新帳戶',
      'Valid email address': '輸入有效郵件地址',
      'Use 8 or more characters with a mix of letters and numbers': '輸入8 個或以上字母、符號和數字',
      'Confirm password': '確認密碼',
      'Enter password again': '再次輸入密碼',
      'Company name': '公司名稱',
      Location: '地域',
      Register: '注冊',
      'Already have an account?': '已有帳戶？',
      'Online Training Class': '線上培訓課程',
      Main: '主頁',
      Course: '課程',
      Mission: '任務',
      User: '管理用戶',
      Report: '報告',
      Logout: '登出',
      'Copyright 2022 Hoplite Technology Limited, All Rights Reserved.': '2022 犀兵科技有限公司版權所有，保留所有權利。',
      'Courses / Quizzes List': '課程 / 測驗',
      'Add mission': '新增任務',
      'Mission name': '任務名稱',
      'End Date': '結束日期',
      'End Time': '結束時間',
      Title: '標題',
      Score: '分數',
      score: '分數',
      scores: '分數',
      Description: '描述',
      'Max 100 words': '最多 100 個字',
      Department: '部門',
      Save: '儲存',
      'Upload image': '上傳圖片',
      Select: '選擇',
      'Video URL': '影片網址',
      Return: '返回',
      Confirm: '確認',
      Edit: '編輯',
      Completed: '已完成',
      Approved: '已審批',
      'User List': '用戶列表',
      Admin: '管理者',
      Status: '狀態',
      ACTIVE: '有效用戶',
      INACTIVE: '無效用戶',
      Active: '有效用戶',
      Inactive: '無效用戶',
      Tel: '電話',
      'Job type': '雇傭類型',
      Role: '用戶類型',
      Company: '公司',
      'Last login': '上次登錄',
      'Add user': '添加用戶',
      'Add new user': '添加新用戶',
      'Full-Time': '全職',
      'Part-Time': '兼職',
      None: '不適用',
      'full-time': '全職',
      'part-time': '兼職',
      none: '不適用',
      'platform-admin': '平台管理者',
      'division-admin': '部門管理者',
      trainee: '實習生',
      'Platform-Admin': '平台管理者',
      'Division-Admin': '部門管理者',
      'Platform Admin': '平台管理者',
      'Division Admin': '部門管理者',
      Trainee: '實習生',
      FILTERS: '過濾',
      RESET: '重置',
      'Courses / Quizzes Report': '課程/測驗報告',
      'Export report': '輸出成績報告',
      'Export Report': '成績輸出',
      Quiz: '測驗',
      'Completed rate': '完成率',
      'Average score': '平均分',
      'Passing rate': '合格率',
      'Send Reminder Email to Uncompleted Users': '向未完成的用戶發送提醒電郵',
      Back: '返回',
      'Start Time': '開始時間',
      'Completed Time': '完成時間',
      Reminder: '提醒電郵',
      Send: '發送',
      'Mission Report': '任務報告',
      'Submit rate': '提交率',
      'Approval rate': '審批率',
      'Approve Submission': '審批提交',
      'Uploaded Time': '提交時間',
      'Approval Time': '審批時間',
      Approval: '已審批',
      'Your course': '你的課程',
      'Your mission': '你的任務',
      'Your result': '你的成績',
      Hi: '你好',
      'Let\'s learn something new today': '今天我們來學點新知識',
      hr: '小時',
      Performance: '成績表現',
      'Hour spent': '花費時間',
      Expired: '已到期',
      'Mission step': '任務步驟',
      'This mission is time over. Please contact the admin re-open.': '這個任務結束了，請聯絡管理員重新開啟。',
      Close: '關閉',
      'Please enter the valid email': '請輸入有效電郵',
      'Delete User': '刪除用戶',
      delete_user: '用戶：{{uid}} 將被刪除。',
      Cancel: '取消',
      'Reset password': '重設密碼',
      'Reset this user password': '重置此使用者密碼',
      'Reset password successfully': '重置密碼成功',
      Copy: '複製',
      'This UID has been created in this company.': '此 UID 已在該公司中創建。',
      Export: '成績輸出',
      Selected: '已選',
      'Select All': '全選',
      Approve: '批准',
      'Items per page': '每頁顯示',
      'Online training course': '課程 / 測驗',
      Weekly: '每週',
      'Edit user': '編輯用戶',
      'Edit mission': '編輯任務',
      'Rows per page': '顯示行數',
      'Welcome to Online Training Class': '歡迎來到網絡安全意識培訓',
    },
  },
  cn_s: {
    translation: {
      'Cybersecurity Awareness Training': '网络安全意识培训',
      English: '英语',
      'Chinese (Simplified)': '简体中文',
      'Chinese (Traditional)': '繁体中文',
      Email: '电邮',
      Password: '密码',
      Language: '语言',
      Login: '登入',
      'Not registered yet?': '没有帐户？',
      'Register now': '立即注册',
      'Register account': '注册新账户',
      'Valid email address': '输入有效邮件地址',
      'Use 8 or more characters with a mix of letters and numbers': '输入8 个或以上字母、符号和数字',
      'Confirm password': '确认密码',
      'Enter password again': '再次输入密码',
      'Company name': '公司名称',
      Location: '地域',
      Register: '注册',
      'Already have an account?': '已有账户？',
      'Online Training Class': '在线培训课程',
      Main: '主页',
      Course: '课程',
      Mission: '任务',
      User: '管理用户',
      Report: '报告',
      Logout: '登出',
      'Copyright 2022 Hoplite Technology Limited, All Rights Reserved.': '2022 犀兵科技有限公司版权所有，保留所有权利。',
      'Courses / Quizzes List': '课程/测验',
      'Add mission': '新增任务',
      'Mission name': '任务名称',
      'End Date': '结束日期',
      'End Time': '结束时间',
      Title: '标题',
      Score: '分数',
      score: '分数',
      scores: '分数',
      Description: '描述',
      'Max 100 words': '最多 100 个字',
      Department: '部门',
      Save: '储存',
      'Upload image': '上传图片',
      Select: '选择',
      'Video URL': '视频网址',
      Return: '返回',
      Confirm: '确认',
      Edit: '编辑',
      Completed: '已完成',
      Approved: '已審批',
      'User List': '用户列表',
      Admin: '管理者',
      Status: '状态',
      ACTIVE: '有效用户',
      INACTIVE: '无效用户',
      Active: '有效用户',
      Inactive: '无效用户',
      Tel: '电话',
      'Job type': '雇佣类型',
      Role: '用户类型',
      Company: '公司',
      'Last login': '上次登录',
      'Add user': '添加用户',
      'Add new user': '添加新用户',
      'Full-Time': '全职',
      'Part-Time': '兼职',
      None: '不适用',
      'full-time': '全职',
      'part-time': '兼职',
      none: '不适用',
      'platform-admin': '平台管理者',
      'division-admin': '部门管理者',
      trainee: '实习生',
      'Platform-Admin': '平台管理者',
      'Division-Admin': '部门管理者',
      'Platform Admin': '平台管理者',
      'Division Admin': '部门管理者',
      Trainee: '实习生',
      FILTERS: '过滤',
      RESET: '重置',
      'Courses / Quizzes Report': '课程/测验报告',
      'Export report': '输出成绩报告',
      'Export Report': '成绩输出',
      Quiz: '测验',
      'Completed rate': '完成率',
      'Average score': '平均分',
      'Passing rate': '合格率',
      'Send Reminder Email to Uncompleted Users': '向未完成的用户发送提醒电邮',
      Back: '返回',
      'Start Time': '开始时间',
      'Completed Time': '完成时间',
      Reminder: '提醒电邮',
      Send: '发送',
      'Mission Report': '任务报告',
      'Submit rate': '提交率',
      'Approval rate': '審批率',
      'Approve Submission': '審批提交',
      'Uploaded Time': '提交时间',
      'Approval Time': '审批时间',
      Approval: '已審批',
      'Your course': '你的课程',
      'Your mission': '你的任務',
      'Your result': '你的成绩',
      Hi: '你好',
      'Let\'s learn something new today': '今天我们来学点新知识',
      hr: '小时',
      Performance: '成绩表现',
      'Hour spent': '花费时间',
      Expired: '已到期',
      'Mission step': '任务步骤',
      'This mission is time over. Please contact the admin re-open.': '这个任务结束了，请联络管理员重新开启。',
      Close: '关闭',
      'Please enter the valid email': '请输入有效电邮',
      'Delete User': '删除用户',
      delete_user: '用户：{{uid}}将被删除。',
      Cancel: '返回',
      'Reset password': '重设密码',
      'Reset this user password': '重置此用户密码',
      'Reset password successfully': '重置密码成功',
      Copy: '复制',
      'This UID has been created in this company.': '此 UID 已在该公司中创建。',
      Export: '成绩输出',
      Selected: '已选',
      'Select All': '全选',
      Approve: '批准',
      'Items per page': '每页显示',
      'Online training course': '课程 / 测验',
      Weekly: '每周',
      'Edit user': '编辑用户',
      'Edit mission': '编辑任务',
      'Rows per page': '显示行数',
      'Welcome to Online Training Class': '欢迎来到网络安全意识培训',
    },
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: sessionStorage.getItem('lang'),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
